import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/products/cart-item-1.webp'
import _imports_1 from '../../../assets/img/icons/close-2.svg'
import _imports_2 from '../../../assets/img/products/cart-item-2.webp'
import _imports_3 from '../../../assets/img/products/cart-item-3.webp'
import _imports_4 from '../../../assets/img/icons/right-long-arrow.svg'


const _hoisted_1 = { class: "row pt-100" }
const _hoisted_2 = { class: "col-xxl-9 col-xl-8 pe-xxl-5" }
const _hoisted_3 = { class: "table-responsive cart-table" }
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = { class: "bg-transparent shadow-none fw-medium text-black title ps-0" }
const _hoisted_6 = { class: "d-flex align-items-center shop-item" }
const _hoisted_7 = { class: "bg-transparent shadow-none lh-1 fw-semibold text" }
const _hoisted_8 = { class: "bg-transparent shadow-none fw-medium text-black title ps-0" }
const _hoisted_9 = { class: "d-flex align-items-center shop-item" }
const _hoisted_10 = { class: "bg-transparent shadow-none lh-1 fw-semibold text" }
const _hoisted_11 = { class: "bg-transparent shadow-none fw-medium text-black title ps-0" }
const _hoisted_12 = { class: "d-flex align-items-center shop-item" }
const _hoisted_13 = { class: "bg-transparent shadow-none lh-1 fw-semibold text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_QuantityCounter = _resolveComponent("QuantityCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "b" }, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-semibold fs-14 pt-0 ps-0 bg-transparent"
              }, " PRODUCT "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-semibold fs-14 pt-0 bg-transparent"
              }, " PRICE "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-semibold fs-14 pt-0 bg-transparent"
              }, " QUANTITY "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-semibold fs-14 pt-0 bg-transparent"
              }, " TOTAL "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-title fw-semibold fs-14 pt-0 bg-transparent"
              })
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Image"
                  }, null, -1)),
                  _createVNode(_component_router_link, { to: "/shop-details" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Laptop", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fw-semibold text-purple" }, " $11.50 ", -1)),
              _createElementVNode("td", _hoisted_7, [
                _createVNode(_component_QuantityCounter)
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fw-semibold text-purple" }, " $11.50 ", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fs-14 fw-semibold text-paragraph" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-transparent border-0 p-0"
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Image"
                  })
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("img", {
                    src: _imports_2,
                    alt: "Image"
                  }, null, -1)),
                  _createVNode(_component_router_link, { to: "/shop-details" }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Camera", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fw-semibold text-purple" }, " $11.50 ", -1)),
              _createElementVNode("td", _hoisted_10, [
                _createVNode(_component_QuantityCounter)
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fw-medium text-purple" }, " $11.50 ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fs-14 fw-semibold text-paragraph" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-transparent border-0 p-0"
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Image"
                  })
                ])
              ], -1))
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[11] || (_cache[11] = _createElementVNode("img", {
                    src: _imports_3,
                    alt: "Image"
                  }, null, -1)),
                  _createVNode(_component_router_link, { to: "/shop-details" }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Tablet", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fw-medium text-purple" }, " $11.50 ", -1)),
              _createElementVNode("td", _hoisted_13, [
                _createVNode(_component_QuantityCounter)
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fw-medium text-purple" }, " $11.50 ", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("td", { class: "bg-transparent shadow-none lh-1 fs-14 fw-semibold text-paragraph" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-transparent border-0 p-0"
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Image"
                  })
                ])
              ], -1))
            ])
          ])
        ])
      ])
    ]),
    _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"col-xxl-3 col-xl-4 px-xxl-0\" data-v-5e733f1e><div class=\"sidebar\" data-v-5e733f1e><div class=\"card border-0 shadow-none\" data-v-5e733f1e><div class=\"card-body\" data-v-5e733f1e><h4 class=\"fs-20 fw-semibold p-30 mb-20\" data-v-5e733f1e>Cart Total</h4><form action=\"#\" class=\"coupon-form position-relative mb-10\" data-v-5e733f1e><input type=\"text\" placeholder=\"COUPON CODE\" class=\"w-100 bg_ash h-55 fs-12 text-title border-0 rounded-1\" data-v-5e733f1e><button type=\"submit\" class=\"position-absolute top-0 end-0 text-white border-0 rounded-1 fw-semibold\" data-v-5e733f1e> Apply </button></form><div class=\"table-responsive\" data-v-5e733f1e><table class=\"table text-nowrap align-middle mb-0\" data-v-5e733f1e><tbody data-v-5e733f1e><tr class=\"br-0\" data-v-5e733f1e><td class=\"shadow-none fw-medium text-black title border-0 pb-0 px-0\" data-v-5e733f1e><span class=\"fw-semibold text-optional d-block fs-14 ls-7\" data-v-5e733f1e> SUBTOTAL </span></td><td class=\"shadow-none lh-1 fw-semibold text-title border-0 pb-0 px-0\" data-v-5e733f1e><span class=\"fw-semibold text-title d-block fs-14 ls-7 text-end\" data-v-5e733f1e> $51.00 USD </span></td></tr><tr data-v-5e733f1e><td class=\"shadow-none fw-medium text-black title pt-2 px-0\" data-v-5e733f1e><span class=\"fw-semibold text-optional d-block fs-14 ls-7\" data-v-5e733f1e> TOTAL </span></td><td class=\"shadow-none lh-1 fw-semibold text-title pt-2 px-0\" data-v-5e733f1e><span class=\"fw-semibold text-title d-block fs-14 ls-7 text-end\" data-v-5e733f1e> $51.00 USD </span></td></tr></tbody></table><div class=\"mt-4 px-xxl-1\" data-v-5e733f1e><button class=\"btn style-eleven w-100 d-blockfs-14\" data-v-5e733f1e> Proceed To Checkout<img src=\"" + _imports_4 + "\" alt=\"Image\" data-v-5e733f1e></button></div></div></div></div></div></div>", 1))
  ]))
}